import React, {CSSProperties} from "react";
import styled from "@emotion/styled";

const Loading = styled.div<{size?: number}>`
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0.3;
	background: #090b0f;
	min-width: ${(props) => props.size || 12}em;
	min-height: ${(props) => props.size || 12}em;
	div {
		font-size: 10px;
		text-indent: -9999em;
		width: ${(props) => (props.size || 12) - 2}em;
		height: ${(props) => (props.size || 12) - 2}em;
		border-radius: 50%;
		background: #ffffff;
		background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
		position: absolute;
		animation: load3 1.4s infinite linear;

		&:before {
			width: 50%;
			height: 50%;
			background: #ffffff;
			border-radius: 100% 0 0 0;
			position: absolute;
			top: 0;
			left: 0;
			content: "";
		}
		&:after {
			background: #090b0f;
			width: 75%;
			height: 75%;
			border-radius: 50%;
			content: "";
			margin: auto;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
		}

		@keyframes load3 {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(360deg);
			}
		}
	}
`;

interface IProps {
	borderRadius?: number;
	alignItems?: CSSProperties["justifyContent"];
	when: boolean;
	size?: number;
}

export const MiddleLoading: React.FC<IProps> = (props) => {
	if (!props.when) {
		return null;
	}

	return (
		<Loading
			role={"alert"}
			aria-label={"Loading..."}
			style={{
				borderRadius: props.borderRadius || 0,
				alignItems: props.alignItems,
			}}
			size={props.size}
		>
			<div></div>
		</Loading>
	);
};
